import { useState } from 'react';

const useFormInput = (initialValues) => {
	const [values, setValues] = useState(initialValues);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setValues((prevValues) => ({
			...prevValues,
			[name]: value
		}));
	};

	const resetValues = () => setValues(initialValues);

	return {
		values,
		handleInputChange,
		resetValues,
		setValues
	};
};

export default useFormInput;
